import { Text } from "@/components/ui/baseUi/text"
import { InfinityIcon } from "@images/svgIcons/infinityIcon"
import { OnOffIcon } from "@images/svgIcons/onOffIcon"
import { ProLargeIcon } from "@images/svgIcons/proLargeIcon"
import { word } from "@modules/core/utils/i18n"
import { PublicProfileInfoResume } from "@modules/profile/publicProfile/components/publicProfileInfoResume"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { UserProgramDetailsEntity } from "@modules/programs/entities/userProgramDetailsEntity"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { ProgramType } from "@modules/programs/types/programTypes"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"
import { BoxesIcon } from "lucide-react"
import { useMemo } from "react"

type ProgramSubscriberDetailsHeaderProps = {
  program: UserProgramDetailsEntity | ProgramBundleEntity
  subscriberDetails: ProgramSubscriberEntity | ProgramBundleSubscriberEntity
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscriberDetailsHeader({
  program,
  subscriberDetails,
  className,
  ...props
}: ProgramSubscriberDetailsHeaderProps) {
  const { sidebarNavigateTo } = useSidebar()

  const openUserProfile = () => {
    if (subscriberDetails.id) {
      void sidebarNavigateTo({
        content: <PublicProfileInfoResume userId={subscriberDetails.id} />,
        onHide: () => {
          return Promise.resolve(true)
        },
      })
    }
  }

  const itemIcon = useMemo(() => {
    if (program instanceof ProgramBundleEntity) {
      return <BoxesIcon color="currentColor" className="shrink-0 text-textDefault-caption" width={15} height={15} />
    } else if (program.type === ProgramType.VIRTUAL) {
      return <InfinityIcon color="currentColor" className="shrink-0 text-textDefault-caption" width={15} height={15} />
    } else if (program.type === ProgramType.PRO) {
      return <ProLargeIcon color="currentColor" className="shrink-0 text-textDefault-caption" width={15} height={15} />
    } else
      return <OnOffIcon color="currentColor" className="shrink-0 text-textDefault-caption" width={15} height={15} />
  }, [program])

  return (
    <HuAvatarCardSidebar
      id={subscriberDetails.id ?? undefined}
      avatar={subscriberDetails.avatar}
      firstname={subscriberDetails.firstname ?? undefined}
      lastname={subscriberDetails.lastname ?? undefined}
      username={subscriberDetails.username ?? undefined}
      prefixUsername={subscriberDetails.username ? "@" : undefined}
      nationality={subscriberDetails.nationality}
      email={subscriberDetails.email}
      onAvatarClick={openUserProfile}
      className={className}
      {...props}
      topContent={
        <div className="flex w-full flex-col items-center pt-2">
          {!(program instanceof ProgramBundleEntity) && program.type === ProgramType.ONOFF ? (
            <Text fontStyle="TM">{word("program.label.athlete")}</Text>
          ) : (
            <Text fontStyle="TM">{word("program.label.mixed_subscribers")}</Text>
          )}

          <div className="flex max-w-[80%] items-center gap-2 text-textDefault-caption">
            <Text fontStyle="LM">{itemIcon}</Text>
            <Text fontStyle="LM" className="line-clamp-2 wrap-anywhere capitalize">
              {program.name}
            </Text>
          </div>
        </div>
      }
    />
  )
}
